// Lib
import React from 'react';

// Components
import TableTextStylePopupContent from './TableTextStylePopupContent';

// Utils
import { prop } from '../../../../../common/utils/immutableHelper';

// Hooks
import usePauseEditorFocusWhileComponentRendered from '../../../../mobile/boardsPage/editing/usePauseEditorFocusWhileComponentRendered';

// Types
import type { MobileTextStyleRichTextSheetProps } from '../../../../mobile/toolbar/tools/richTextTool/MobileTextStyleRichTextSheet';

/**
 * Renders the mobile text style sheet for selected table cells.
 */
const MobileTableTextStyleSheetContent: React.FC<MobileTextStyleRichTextSheetProps> = (props) => {
    usePauseEditorFocusWhileComponentRendered();

    const element = prop(0, props.selectedElements);

    return <TableTextStylePopupContent element={element} />;
};

export default MobileTableTextStyleSheetContent;
